export default {
    activateuser: {
        headerLabel: 'Accueil des utilisateurs',
        accountActivation: 'Activation du compte',
        step1: {
            header: 'Bienvenue sur notre plateforme!',
            subHeader: 'Choisissez comment vous voulez vous connecter à votre compte',
            description:
                'Pour un processus de login plus simple, nous vous recommandons de connecter votre compte à au moins un des services suivants.',
            OR: 'ou',
            emailAndPassword: 'Utilisez votre propre adresse email',
        },
        step2: {
            header: "Utiliser l'email et le mot de passe",
            description:
                "Il s’agit de l'adresse email principale qui sera associée à votre compte. Nous vous recommandons d'utiliser un email différent de votre adresse email universitaire afin de conserver l'accès à vos données après votre diplôme. Dans les paramètres de votre compte, vous pouvez facilement contrôler les emails que vous souhaitez recevoir de notre part.",
            invalidEmail: "L'email fourni n'est pas une adresse email valide.",
            passwordsNotMatch: 'Les mots de passe doivent correspondre',
            passwordDescription01:
                'Pour assurer la sécurité de votre compte, vous devez définir un nouveau mot de passe. Veuillez créer un mot de passe avec les éléments suivants :',
            passwordDescription02: 'Minimum 8 caractères',
            passwordDescription03: 'Au moins un caractère minuscule (a-z)',
            passwordDescription04: 'Au moins un caractère majuscule (A-Z)',
            passwordDescription05: 'Au moins un chiffre ou un symbole spécial (0-9, !#$ etc)',
            passwordDescription06: 'Au moins 6 caractères uniques',
            repeatPassword: 'Répéter le mot de passe',
        },
        step3: {
            header: "Activation de l'utilisateur",
            loadingHints: {
                0: 'Chargement des données utilisateur',
                1: 'Préparez-vous',
                2: 'De nouvelles possibilités disponibles',
                3: 'Presque terminé!',
            },
            successHeader: 'Votre compte est maintenant prêt!',
            successSubheader: 'Vous pouvez désormais accéder à des fonctionnalités exclusives !',
            errorHeader: "Impossible d'activer le compte",
            ifWrongContact: "Si vous pensez qu'il y a une erreur, veuillez contacter le support.",
            contactForHelp: "Demandez de l'aide",
            goBack: 'Retour',
        },
    },
    assessments: {
        general: {
            checkMyProgress: 'Vérifier ma progression',
            getStarted: 'Commencez!',
            getToKnowYourself: 'Apprenez à vous connaître',
            getToKnowYourselfBold: 'Apprenez à <strong>vous </strong> connaître',
            getToKnowYourFuture: 'Apprenez à connaître votre futur.',
            getToKnowYourFutureBold: 'Apprenez à connaître votre <strong>futur</strong>.',
            openAssessments: 'Assessments ouverts',
            openAssessment: 'Assessment ouvert',
            unlock: 'Déverrouillez les tests',
            testYourself: 'Testez vous',
            takeTheFreeTests: 'Faites les tests gratuits',
            youOwnThisProduct: 'Ce produit vous appartient',
            startTest: 'Démarrer le test',
            startTests: 'Démarrer les tests',
            continue: 'Continuer',
            showReport: 'Voir le rapport',
            showYourReports: 'Voir les rapports',
            showYourReport: 'Voir votre rapport',
            continueFreeTests: 'Continuer les tests gratuits',
            continueTheTest: 'Continuer le test',
            estimatedTime: '~ {min} min',
        },
        landing: {
            section1: {
                title: 'Testez vous',
                description01:
                    "Bienvenue à l'Assessment Center - c'est ici que commence votre parcours professionnel.",
                description02:
                    "C'est ici que vous pouvez passer les <strong>Aon Assessments </strong>, des tests utilisés par les recruteurs du monde entier, qui vérifient vos aptitudes et votre préparation à une future carrière.",
                freemium: {
                    description:
                        'Passez ces tests pour mesurer vos points forts et obtenir des rapports efficaces sur vos compétences.',
                    price: 'Gratuit',
                    numTests: '3 tests',
                    timeEstimated: 'environ 27 min',
                },
                premium: {
                    description:
                        "C'est <strong>là que ça se passe</strong>. Passez ce test 3 en 1 pour découvrir les parcours professionnels que vous devriez poursuivre et obtenez un Rapport de Candidat complet.",
                    numTests: 'Test 3-en-1',
                    timeEstimated: 'environ 60 min',
                    sampleReport: '↓Télécharger un exemple de rapport',
                    candidateReport: 'Rapport du Candidat',
                    candidateReportDescription:
                        "Une fois que vous aurez terminé ces tests, vous recevrez un Rapport de Candidat complet avec une vue d'ensemble de vos résultats, y compris des conseils pour améliorer vos compétences personnelles, les compétences auxquelles vous devriez prêter attention, les meilleures opportunités par lesquelles commencer, quelle devrait être votre prochaine étape, et plus encore.",
                },
            },
            section2: {
                title: 'Comment ces tests vous aideront-ils à être embauché ?',
                t1: 'Vous connaîtrez vos <strong>compétences</strong>',
                t2: 'Vous réaliserez votre <strong>potentiel</strong>',
                t3: 'Vous aurez un <strong> parcours professionnel</strong> clair',
                t4: 'Vous augmenterez votre <strong>confiance</strong>',
            },
            section3: {
                title: "Apprenez à connaître vos points forts et les possibilités de carrière qui s'offrent à vous afin de favoriser votre développement et votre évolution de carrière.",
            },
            section4: {
                title: "Prenez de l'avance sur vos concurrents dès aujourd'hui",
                description:
                    'en remplissant des évaluations utilisées par les recruteurs du monde entier dans des entreprises comme Deloitte, Siemens, Burger King, Vodafone ou P&G.',
            },
            section5: {
                title: 'Foire Aux Questions',
                thisPage: 'cette page',
                question01: {
                    q: 'Que sont les Aon Assessments ?',
                    a: "Les Aon Assessments sont des tests reconnus mondialement qui aident les entreprises du monde entier à identifier les meilleurs candidats pour un poste. Avec l'aide des évaluations des talents, les recruteurs peuvent aller au-delà des CV, des notes scolaires, des certificats d'études et des diplômes universitaires pour savoir si un candidat correspond bien à leurs attentes.\n                <br><br>\n            Ces solutions sont généralement réservées <strong>aux recruteurs</strong> - ici, vous avez une opportunité <strong>exclusive</strong> de vous entraîner et d'obtenir vos résultats avant votre entretien d'embauche.",
                },
                question02: {
                    q: 'Dois-je payer pour passer ces évaluations ?',
                    a: "Vous pouvez passer 4 tests gratuitement - <i>Comportement au travail</i>, <i>Raisonnement numérique</i>, <i>Réflexion déductive-logique</i> et <i>Raisonnement inductif-logique</i>. Ces tests mesurent vos compétences et vos aptitudes et constituent un excellent moyen de connaître vos forces et vos faiblesses.\n\n <br><br>Cependant, si vous souhaitez avoir un aperçu complet de vos prédispositions, obtenir des indications professionnelles sur les parcours les plus adaptés et faire un grand pas vers votre réussite future, vous pouvez également accéder au test 3-en-1 et obtenir un rapport complet pour 79 €. <br><br>Pour l'accès étendu, il suffit de <a href={premiumLink}>cliquer ici</a> et de payer par carte - nous utilisons une méthode de paiement sécurisée.\n",
                },
                question03: {
                    q: 'Pourquoi devrais-je passer ces tests?',
                    a: "\"\n                Les recruteurs du monde entier utilisent les tests d'évaluation AON dans leur processus de sélection des candidats. En les complétant à l'avance et en leur présentant des rapports prêts à l'emploi, vous avez une excellente occasion d'étonner les recruteurs. Comment? \n",
                },
                question04: {
                    q: 'Comment puis-je me préparer à ces tests?',
                    a: 'Vous pouvez lire tout ce qui concerne les exigences techniques et la manière de vous préparer aux évaluations sur <a href={link} target="_blank">cette page</a>.  Vous y trouverez également des supports pour vous aider à passer le test!',
                },
                question05: {
                    q: 'Où puis-je trouver ces évaluations?',
                    a: "En règle générale, votre recruteur peut vous demander de passer ces tests - sinon, vous ne les trouverez nulle part ailleurs. Il s'agit d'une occasion exclusive pour vous de vous entraîner, d'en savoir plus sur vous-même et sur votre future carrière.",
                },
                question06: {
                    q: 'Combien de fois puis-je passer les tests ?',
                    a: "Vous n'avez droit qu'à un essai pour chaque test. Aucun rattrapage! Assurez-vous de disposer de conditions confortables pour le passer afin de tirer le meilleur parti de cette opportunité. Vous pouvez vous familiariser avec le test en regardant des vidéos d'instruction et en faisant un exercice pratique avant de passer le test.",
                },
                question07: {
                    q: 'En quelle langue sont ces tests?',
                    a: "\n                La langue par défaut de ces tests est l'anglais, mais chacun d'entre eux offre un choix de langues. Vous pouvez vérifier quelles langues sont disponibles et choisir celle qui vous convient le mieux avant de passer le test. \n",
                },
                question08: {
                    q: "Y a-t-il une date d'expiration pour les tests 3 en 1 une fois que je les ai payés ?",
                    a: 'Non! Une fois votre paiement accepté, vous pouvez passer les tests 3 en 1 quand vous le souhaitez. Prenez votre temps pour vous préparer et commencez les évaluations au moment qui vous convient le mieux.',
                },
            },
        },
        center: {
            banner: {
                title: 'Vérifiez vos progrès',
                subtitle: 'Voici un aperçu de votre progression dans les bilans de carrière',
                moreInfo: "Plus d'informations",
                yourProgress: 'Vos progrès',
                quote: "Fixer des objectifs est la première étape pour transformer l'invisible en visible.",
            },
            list: {
                timeEstimated: 'env. {minutes} min',
                freemium: {
                    intro: "\n                    C'est la première étape de votre parcours de développement personnel! <br />\n                      Passez ces tests pour mesurer vos points forts et obtenir des rapports efficaces sur vos\n                     compétences.\n",
                },
                premium: {
                    intro: "\n                    C'est là que ça se passe.<br />\n       Passez ces tests pour savoir quelles sont les carrières qui vous conviennent et obtenez un\n                      <strong>Rapport de candidature</strong> complet.\n",
                    description:
                        '\n                    Votre <strong>Rapport de Candidat</strong> vous donnera un aperçu complet\n                     de vos résultats, y compris des <strong>conseils</strong> pour améliorer votre\n                     ensemble de compétences personnelles, les <strong>compétences</strong> auxquelles vous devriez prêter attention, les meilleures <strong>opportunités</strong> pour commencer, quelle devrait être votre <strong>prochaine étape</strong>, et plus encore.\n',
                },
            },
            instruments: {
                344: {
                    name: 'Test de raisonnement déductif et logique',
                    description:
                        "Ce test mesure votre capacité à utiliser vos connaissances et à appliquer des règles - il évalue votre capacité d'analyse et de résolution de problèmes.",
                    estimatedTime: '9',
                },
                383: {
                    name: 'Test de raisonnement inductif et logique',
                    description:
                        "Êtes-vous capable d'identifier les règles et les interrelations? Vérifiez-le avec ce test qui mesure vos capacités d'analyse et de résolution de problèmes.",
                    estimatedTime: '9',
                },
                390: {
                    name: 'Comportement lié au travail',
                    description:
                        'Quel employé seriez-vous ? Quels sont les traits de personnalité que vous possédez? Découvrez-le en faisant ce test qui identifie vos traits de personnalité au travail.',
                    estimatedTime: '30',
                },
                721: {
                    name: 'Test de raisonnement numérique',
                    description:
                        "Êtes-vous à l'aise avec les chiffres ? Ce test mesure votre compréhension des informations numériques et votre capacité à tirer des conclusions logiques.",
                    estimatedTime: '9',
                },
                5392: {
                    name: 'Mémoire au travail',
                    description:
                        'Pouvez-vous rester concentré ? Ce test mesure la capacité à traiter et à retenir des informations dans des environnements distrayants.',
                    estimatedTime: '15',
                },
                82013: {
                    name: 'flexTest',
                    description:
                        "Quels sont vos centres d'intérêt? Ce questionnaire vous aidera à déterminer les carrières qui vous intéressent.",
                    estimatedTime: '15',
                },
            },
        },
        dialog: {
            header: 'Commencez vos Aon Assessments',
            consent:
                "Je comprends qu'Aon est responsable de mes données liées à cette évaluation, et j'accepte leurs conditions générales.\n                  J'accepte également que Highered transfère mon nom à Aon pour générer mon rapport.",
            startTest: 'Démarrer le test',
            consentErrorTitle: 'Erreur. Veuillez accepter les conditions.',
            consentErrorMessage:
                'Un problème est survenu lors de la validation. Avez-vous confirmé votre email?',
        },
    },
    "<br><br>\\n           Premier - vous arrivez préparé avec une partie du processus de recrutement déjà effectuée, ce qui vous fera instantanément prendre de l'avance sur les autres candidats":
        {
            '\\n            <br><br>\\n Deuxième - vous abordez votre recrutement avec un esprit clair':
                {
                    " Vous connaissez vos points forts et ce que l'avenir vous réserve - motivation instantanée et véritable regain de confiance garantis! Les recruteurs pourront le dire":
                        {
                            '"': '\n I reclutatori di tutto il mondo usano i test di valutazione AON nel loro processo di selezione dei candidati. Completandoli in anticipo e presentando loro dei resoconti pronti, avrai una grande opportunità di stupire veramente i reclutatori. Come? \n <br><br>\n Primo - arrivi preparato con parte del processo di reclutamento già fatto, il che ti farà immediatamente passare in vantaggio rispetto agli altri candidati.\n <br><br>\n Secondo - ti avvicini al reclutamento con una mente lucida. Conosci i tuoi punti di forza e cosa ti riserva il futuro - motivazione immediata e una vera e propria iniezione di fiducia garantita! I reclutatori se ne accorgeranno.',
                        },
                },
        },
    calendar: {
        header: 'Calendrier',
        myCalendar: 'Mon calendrier',
        noCalendar: "Votre service de carrière n'a pas encore activé la fonction calendrier.",
        goBackBtn: 'Retour',
        calendarNotReady:
            'La fonctionnalité "mon calendrier" n\'est pas encore prête. Bientôt disponible !',
        noUpcomingAppointments: "Vous n'avez pas de rendez-vous à venir.",
        appointmentMissing: 'Rendez-vous non actif',
        appointmentNotActive:
            "Désolé, vous avez essayé d'afficher un rendez-vous qui n'existe pas ou qui n'est pas actif.",
        appointmentNotHavingAvailability:
            "Désolé, ce rendez-vous n'a pas de disponibilité pour le moment. Revenez plus tard.",
        appointmentMissingRules: "Le rendez-vous n'est pas disponible",
        needToCompleteProfile: 'Complétez votre profil',
        noUpcomingAppointmentsPleaseBook: 'Prenez rendez-vous pour débloquer votre calendrier.',
        bookAppointment: 'Prendre rendez-vous',
        bookAnotherAppointment: 'Prendre un rendez-vous',
        attendedAppointments: 'Les rendez-vous auxquels vous avez assistés',
        aboutAppointments: {
            header: 'A propos des rendez-vous',
            button: 'À propos de',
            block1: {
                header: "Qu'est-ce qu'un rendez-vous?",
                paragraph1:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                paragraph2:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
            },
            block2: {
                header: "Qui puis-je contacter pour plus d'informations ?",
                paragraph1:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                paragraph2:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
            },
        },
        bookAnAppointment: 'Prendre un rendez-vous',
        backToCalendarBtn: 'Revenir au calendrier',
        backToBookingBtn: 'Revenir à la liste des rendez-vous',
        firstAvailable: 'Premier disponible',
        loadingAppointment: 'Chargement ...',
        bookModal: {
            title: 'Confirmer la réservation',
            with: 'Avec',
            confirm: 'Confirmez',
            continue: 'Continuer',
            cancel: 'Fermer',
            first: {
                title: "Il s'agit de votre premier rendez-vous",
                description:
                    "Pour être sûr de recevoir l'invitation à l'événement, veuillez confirmer que vous avez accès à un calendrier personnel par le biais de ce compte email",
                ok: 'OK',
                wrongEmail: 'Mauvaise adresse email?',
            },
            changeEmail: {
                title: 'Sélectionnez le calendrier associé à votre email',
                inputPlaceholder: "Saisir l'adresse email ...",
                ok: 'OK',
                back: 'Utiliser par défaut',
            },
            unknownErrorHeader: "Une erreur s'est produite en essayant de plannifier",
            unknownErrorBody:
                'Veuillez essayer de réserver un autre créneau, et si cela ne fonctionne pas, contactez le support.',
            confirmationHeader: 'Votre rendez-vous est pris !',
            bookedTheFollowing: 'Détails :',
            emailWillBeSent: 'Un email sera envoyé à',
            withConfirmation: 'vous demandant de confirmer votre présence.',
        },
        dateDetailsModal: { title: 'Rendez-vous le' },
        completedYourProfile:
            'Vous devez compléter votre profil pour avoir accès au système de calendrier.',
        toMyProfile: 'Modifier mon profil',
    },
    chat: {
        profileSharingConfirmDialog: {
            title: '{nom} veut voir votre profil',
            content: 'Voulez-vous partager votre profil avec cette personne?',
            share: 'Partager le profil',
            reject: 'Non',
        },
    },
    companyDetail: {
        locations: {
            header: 'Localisations',
            viewAll: 'Tout voir',
            noLocations: 'Aucune localisation',
            allLocations: 'Toutes les localisations',
        },
        jobModule: {
            header: 'Top offres',
            viewAllJobs: 'Voir toutes les offres de {companyName}',
            noPositions: "{companyName} n'a actuellement aucun poste à pourvoir sur Highered.",
            defaultLabel: 'Offres vacantes',
        },
        videos: {
            header: 'Vidéos',
            noVideos: 'Aucune vidéo',
            noMoreVideos: 'Plus aucune vidéo',
            moreVideosFrom: 'Plus de vidéos de {companyName}',
        },
        articles: {
            header: 'Articles',
            noArticles: 'Aucun article',
            noMoreArticles: 'Plus aucun article',
            moreArticlesFrom: "Plus d'articles de {companyName}",
        },
    },
    components: {
        builders: {
            searchable: { create: 'Créez' },
            yearMonthPicker: { defaultSelect: 'Sélectionnez un mois' },
            localeDropdown: {
                languages: { en: 'Anglais', cn: 'Chinois', fr: 'Français' },
            },
        },
        miscellaneous: {
            verifyModule: {
                title: "Vérifiez l'email de votre école",
                description:
                    "Il s'agit d'un processus rapide qui vous donnera accès \n                          à des fonctionnalités exclusives telles que des offres d'emploi uniques, des  \n                     tests de compétences et des ressources professionnelles.",
                verificationPending: 'Vérification en attente',
                weHaveSentAnEmail:
                    'Nous avons envoyé un email à\n                                <strong>{studentEmail}</strong> pour\n                                que vous puissiez vous identifier. Assurez-vous de\n                                vérifier vos spams, car de nombreuses écoles sont\n                                assez strictes sur les emails entrants.',
                verifyMe: 'Vérifiez',
                resendVerifyEmail: "Renvoyer l'email de vérification",
                cancelVerification: 'Annuler la vérification',
                emailSent: 'Email envoyé',
                emailSentMessage:
                    "L'email a été envoyé avec succès. Si vous ne le recevez pas, contactez-nous à support@highered.global.",
                resendErrorTitle: "Erreur lors du renvoi de l'email.",
                resendErrorMessage:
                    "Impossible de renvoyer l'email de vérification. Veuillez nous contacter à support@highered.global.",
                verificationCancelledTitle: 'Vérification annulée',
                verificationCancelledMessage: 'La vérification a été annulée avec succès',
                cancelErrorTitle: "Erreur lors de l'annulation",
                cancelErrorMessage:
                    "Impossible d'annuler la vérification. Veuillez nous contacter à support@highered.global.",
            },
            verifyModuleDialog: {
                title: "Vérifiez l'email de votre école",
                university: 'Ecole',
                studentEmail: 'Votre adresse email école',
                studentEmailPlaceholder: 'Email école',
                message: 'Message',
                verify: 'Vérifiez',
                sendRequest: 'Envoyez la demande',
                verificationInProcess: 'Vérification en cours',
                emailHasBeenSentTo:
                    'Un email a été envoyé à <strong>{email}</strong>. Suivez les instructions pour vérifier votre connexion à <strong>{schoolName}</strong>.',
                verificationRequestSentNonAcademic:
                    'Les Services Carrière de <strong>{schoolName}</strong> devront vérifier votre connexion. Vous serez informé par email lorsque cela se produira.',
                ifNoEmailRecieved:
                    "Si vous n'avez pas reçu l'email de vérification, veuillez nous contacter.",
                contactHelp: 'Un problème ? Contactez-nous',
                doNotHaveAcademicEmail: "Je n'ai pas d'adresse email école",
                doubleCheckEmail:
                    'Veuillez vérifier que cette adresse email est correcte et que vous y avez accès.',
                haveAcademicEmail: "J'ai une adresse email école",
                noAcademicEmailInfo:
                    "Si vous n'utilisez pas d'adresse email école, votre demande devra être approuvée manuellement par les services carrière de votre établissement. Vous devez donc fournir un court message pour vous identifier.",
                alreadyVerifiedInfo: 'Vous êtes déjà identifié dans cette école.',
            },
        },
        navigation: {
            navigation: {
                myPage: 'Ma page',
                jobs: 'Offres',
                companies: 'Entreprises',
                masterclasses: 'Masterclasses',
                assessments: 'Assessments',
                countryGuides: 'Guides des Pays',
                goToHaigui: 'Offres en Chine',
                signIn: "Se connecter / S'inscrire",
                vfairs: 'Événements Virtuels',
                events: 'Événements',
                newFeature: 'Nouvelle fonctionnalité !',
            },
            profileNavigation: { signOut: 'Se déconnecter' },
            sidebar: {
                myPage: 'Ma page',
                myProfile: 'Mon profil',
                findJobs: 'Trouver des offres',
                findCompanies: 'Trouver des entreprises',
                masterclasses: 'Masterclasses',
                assessments: 'Assessments',
                countryGuides: 'Guides des Pays',
                goToHaigui: 'Offres en Chine',
                virtualFairs: 'Événements Virtuels',
                signIn: "Se connecter / S'inscrire",
                logOut: 'Se déconnecter',
            },
            backToCalendar: 'Revenir au calendrier',
            allBooths: 'Toutes les stands',
            home: 'Accueil',
        },
        smart: {
            companyModule: {
                followJob: 'Ajouter aux favoris',
                followCompany: "Suivre l'entreprise",
                unFollowJob: 'Retirer des favoris',
                unFollowCompany: "Ne plus suivre l'entreprise",
                favoritedTitle: 'Enregistré dans les favoris',
                favoritedMessage:
                    'Cette offre a été enregistrée dans vos favoris. Retrouvez vos offres favorites sur Ma Page.',
                unfavoritedTitle: 'Supprimé des favoris',
                unfavoritedMessage: 'Cette offre a été supprimée de vos favoris.',
                favoriteErrorTitle: "Une erreur s'est produite",
                favoriteErrorMessage:
                    "Nous n'avons pas été en mesure de mettre cette offre en favoris",
                showAllCompanies: 'Afficher toutes les entreprises',
                showOnlyCompaniesLiveOnChat:
                    'Afficher uniquement les entreprises en ligne sur le chat',
            },
            profileModule: {
                profileCompletion: 'Profil complet',
                profileCompletionEncouragement:
                    'Mettez-vous en valeur auprès des employeurs en complétant les derniers {percentageLeft} de votre profil.',
                gotoProfilePage: 'Mettre à jour le profil',
                profileCompleted: 'Profil complété',
                profileCompletedWhatsNext:
                    'Saviez-vous que la plupart des employeurs utilisent des assessments en ligne dans leurs processus de recrutement ? Entraînez-vous dès maintenant et obtenez des aperçus sur vos forces et vos faiblesses.',
                gotoTestsPage: "Aller à l'assessment center",
                authIndication: {
                    title: "Trouvez l'emploi de vos rêves",
                    description:
                        "Voulez-vous avoir accès à des offres d'emploi propres à votre école et à des tests qui vous permettront d'optimiser votre recherche d'emploi ? Créez facilement un utilisateur avec Google, LinkedIn ou Facebook dès aujourd'hui.",
                    action: 'Allons-y',
                },
                toProfileHint: 'Vers mon profil',
                toProfileUncompletedHint:
                    "Votre profil n'est pas complet à 100%. Veuillez le compléter afin de maximiser votre employabilité.",
                profileActions: {
                    addFirstName: 'Ajoutez prénom',
                    addLastName: 'Ajouter nom',
                    addNationality: 'Ajouter nationalité',
                    addPhoneNumber: 'Ajoutez votre numéro de téléphone',
                    addLanguage: 'Ajouter une langue',
                    addEducation: 'Ajouter votre parcours scolaire',
                    addEmail: 'Ajoutez votre email',
                    addGender: 'Ajoutez votre genre',
                },
            },
            featuredCompanies: { label: 'Entreprises en vedette' },
            featuredPositions: { label: 'Offres en vedette' },
            featuredResource: {
                header: 'Participez à la conférence virtuelle',
                cta: 'Regardez maintenant !',
                wechatSignupHeader:
                    'Suivez le compte WeChat de Highered pour obtenir des mises à jour.',
                wechatSignupCta: 'Scanner le code maintenant !',
            },
        },
    },
    '"': 'Escanear o código agora!',
    cts: {
        filterNames: {
            employment_types: "Types d'emploi",
            education_level: 'Niveaux académiques',
            job_category: 'Spécialisations',
            address: 'Localisations',
            sector: 'Secteurs',
            exclude_school_id: 'Exclure',
            languages: 'Langues',
        },
        excludeSchoolIds: {
            '-1': 'Postes partagés',
            unknownSchoolId: 'Ecole Partenaire EFMD',
        },
        educationLevels: {
            BACHELORS_OR_EQUIVALENT: 'Bachelors',
            MASTERS_OR_EQUIVALENT: 'Masters',
            DOCTORAL_OR_EQUIVALENT: 'PHD',
            MBA_OR_EQUIVALENT: 'MBA',
            DBA_OR_EQUIVALENT: 'DBA',
        },
        employmentTypes: {
            FULL_TIME: 'Temps plein',
            INTERN: 'Stage',
            TEMPORARY: 'Temps partiel',
            PART_TIME: 'Temps partiel',
        },
        startDate: 'Début',
        educationFields: {
            ACCOUNTING_AND_FINANCE: 'Comptabilité et finances',
            ADMINISTRATIVE_AND_OFFICE: 'Administratif',
            ADVERTISING_AND_MARKETING: 'Publicité et marketing',
            ART_FASHION_AND_DESIGN: 'Art, mode et design',
            BUSINESS_OPERATIONS: 'Business Operations',
            COMPUTER_AND_IT: 'Informatique et IT',
            CUSTOMER_SERVICE: 'Service client',
            EDUCATION: 'Éducation',
            HEALTHCARE: 'Santé',
            HUMAN_RESOURCES: 'Ressources humaines',
            INSTALLATION_MAINTENANCE_AND_REPAIR: 'Maintenance et réparation',
            LEGAL: 'Droit',
            MANAGEMENT: 'Management',
            MANUFACTURING_AND_WAREHOUSE: 'Industrie et entrepôt',
            MEDIA_COMMUNICATIONS_AND_WRITING: 'Communication médias',
            OIL_GAS_AND_MINING: 'Énergie',
            PROTECTIVE_SERVICES: 'Services à la personne',
            REAL_ESTATE: 'Immobilier',
            SALES_AND_RETAIL: 'Commerce et retail',
            SCIENCE_AND_ENGINEERING: 'Sciences et ingénierie',
            SOCIAL_SERVICES_AND_NON_PROFIT: 'Social et association',
            TRANSPORTATION_AND_LOGISTICS: 'Transport et logistique',
        },
        sectors: {
            Consulting: 'Consulting',
            'Consumer Goods': 'Biens de consommation',
            'Financial Services / Banking': 'Services financiers / Banque',
            'Goverment / Public Administration / Non Profit':
                'Gouvernement / Administration publique / Sans but lucratif',
            'International Trade & Development': 'Commerce International et Développement',
            Manufacturing: 'Industrie',
            'Media / Entertainment': 'Médias / Divertissement',
            'Petroleum / Energy': 'Pétrole / Énergie',
            'Pharma / Healthcare / Biotech': 'Pharma / Santé / Biotech',
            'Real Estate / Construction / Infrastructure':
                'Immobilier / Construction / Infrastructure',
            'Technology (IT) / Telecom': 'Technologie ( IT ) / Télécom',
            'Transportations & Logistics': 'Transport et Logistique',
            Other: 'Autre',
        },
        countries: {
            'China (Hong Kong SAR)': 'Hong Kong',
            'Costa Rica': 'Costa Rica',
            'Europe & Sub-Saharan Africa': 'Europe et Afrique Sub-Saharienne',
            'Hong Kong': 'Hong Kong',
            'Korea, South': 'Corée du Sud',
            'New Zealand': 'Nouvelle-Zélande',
            'Papua-Ny Guinea': 'Papouasie-Nouvelle-Guinée',
            'Puerto Rico': 'Porto Rico',
            'Saudi Arabia': 'Arabie Saoudite',
            'South Africa': 'Afrique du Sud',
            'South Korea': 'Corée du Sud',
            'Sri Lanka': 'Sri Lanka',
            'Taiwan (Province of China)': 'Taïwan',
            'The Seychell Islands': 'Seychelles',
            'United Arab Emirates': 'Emirats Arabes Unis',
            'United Kingdom': 'Royaume-Uni',
            'Ivory Coast': "Côte d'Ivoire",
            Afghanistan: 'Afghanistan',
            Algeria: 'Algérie',
            Angola: 'Angola',
            Argentina: 'Argentine',
            Armenia: 'Arménie',
            Australia: 'Australie',
            Austria: 'Autriche',
            Azerbaijan: 'Azerbaïdjan',
            Bahamas: 'Bahamas',
            Bahrain: 'Bahreïn',
            Bangladesh: 'Bangladesh',
            Belarus: 'Bélarus',
            Belgium: 'Belgique',
            Botswana: 'Botswana',
            Brazil: 'Brésil',
            Bulgaria: 'Bulgarie',
            Cambodia: 'Cambodge',
            Canada: 'Canada',
            Chile: 'Chili',
            China: 'Chine',
            Colombia: 'Colombie',
            Congo: 'Congo',
            Croatia: 'Croatie',
            Cyprus: 'Chypre',
            Czechia: 'Tchéquie',
            Denmark: 'Danemark',
            Ecuador: 'Équateur',
            Egypt: 'Égypte',
            Estonia: 'Estonie',
            Ethiopia: 'Éthiopie',
            Fiji: 'Fidji',
            Finland: 'Finlande',
            France: 'France',
            Germany: 'Allemagne',
            Ghana: 'Ghana',
            Greece: 'Grèce',
            Guernsey: 'Guernesey',
            Hungary: 'Hongrie',
            Iceland: 'Islande',
            India: 'Inde',
            Indonesia: 'Indonésie',
            Iraq: 'Irak',
            Ireland: 'Irlande',
            Israel: 'Israël',
            Italy: 'Italie',
            Japan: 'Japon',
            Jersey: 'Jersey',
            Jordan: 'Jordanie',
            Kazakhstan: 'Kazakhstan',
            Kenya: 'Kenya',
            Kuwait: 'Koweït',
            Laos: 'Laos',
            Latvia: 'Lettonie',
            Lebanon: 'Liban',
            Lithuania: 'Lituanie',
            Luxembourg: 'Luxembourg',
            Malaysia: 'Malaisie',
            Malta: 'Malte',
            Mauritania: 'Mauritanie',
            Mauritius: 'Maurice',
            Mexico: 'Mexique',
            Mongolia: 'Mongolie',
            Morocco: 'Maroc',
            Myanmar: 'Myanmar',
            Namibia: 'Namibie',
            Netherlands: 'Pays-Bas',
            Nigeria: 'Nigeria',
            Norway: 'Norvège',
            Oman: 'Oman',
            Pakistan: 'Pakistan',
            Panama: 'Panama',
            Paraguay: 'Paraguay',
            Peru: 'Pérou',
            Philippines: 'Philippines',
            Poland: 'Pologne',
            Portugal: 'Portugal',
            Qatar: 'Qatar',
            Romania: 'Roumanie',
            Russia: 'Russie',
            Senegal: 'Sénégal',
            Serbia: 'Serbie',
            Singapore: 'Singapour',
            Slovakia: 'Slovaquie',
            Slovenia: 'Slovénie',
            Spain: 'Espagne',
            Sudan: 'Soudan',
            Swaziland: 'Swaziland',
            Sweden: 'Suède',
            Switzerland: 'Suisse',
            Syria: 'Syrie',
            Taiwan: 'Taiwan',
            Tanzania: 'Tanzanie',
            Thailand: 'Thaïlande',
            Tonga: 'Tonga',
            Turkey: 'Turquie',
            Ukraina: 'Ukraine',
            Ukraine: 'Ukraine',
            USA: 'USA',
            Uzbekistan: 'Ouzbékistan',
            Vanuatu: 'Vanuatu',
            Vietnam: 'Vietnam',
            Zambia: 'Zambie',
            "Côte d'Ivore (Ivory Coast)": "Côte d'Ivoire",
            Etiopia: 'Éthiopie',
        },
        languages: {
            Aceh: 'Aceh',
            Afrikaans: 'Afrikaans',
            Albanian: 'Albanais',
            Amharic: 'Amharique',
            Arabic: 'Arabe',
            Arakanese: 'Arakanais',
            Armenian: 'Arménien',
            Azeri: 'Azéri',
            Badini: 'Badini',
            Basque: 'Basque',
            Belarusian: 'Biélorusse',
            Bengali: 'Bengali',
            Berber: 'Berbère',
            Bosnian: 'Bosniaque',
            Bulgarian: 'Bulgare',
            Burmese: 'Birmane',
            Cantonese: 'Cantonais',
            Catalan: 'Catalan',
            Cebuano: 'Cebuano',
            Chechen: 'Tchétchène',
            Chin: 'Chin',
            Chinese: 'Chinois',
            Croatian: 'Croate',
            Czech: 'Tchèque',
            Danish: 'Danois',
            Dari: 'Dari',
            Dutch: 'Néerlandais',
            English: 'Anglais',
            Estonian: 'Estonien',
            Faroese: 'Féroïen',
            Filipino: 'Philippin',
            Finnish: 'finlandais',
            French: 'Français',
            German: 'Allemand',
            Greek: 'Grec',
            Greenlandic: 'Groenlandais',
            Hausa: 'Haoussa',
            Hebrew: 'Hébreu',
            Hindi: 'Hindi',
            Hungarian: 'Hongrois',
            Icelandic: 'Islandais',
            Indonesian: 'Indonésien',
            Italian: 'Italien',
            Japanese: 'Japonais',
            Kazakh: 'Kazakh',
            Kinyarwanda: 'Kinyarwanda',
            Kirundi: 'Kirundi',
            Korean: 'Coréen',
            Kurdish: 'Kurde',
            Kurmanji: 'Kurmanji',
            Kven: 'Kven',
            Latin: 'Latin',
            Latvian: 'Letton',
            Lingala: 'Lingala',
            Lithuanian: 'Lituanien',
            Macedonian: 'Macédonien',
            Malagasy: 'malgache',
            Malaysian: 'Malaisien',
            Mandarin: 'Mandarin',
            Mongolian: 'Mongol',
            Nepali: 'Népalais',
            Norwegian: 'Norvégien',
            Oromo: 'Oromo',
            Other: 'Autres',
            Panjabi: 'Punjabi',
            Pashto: 'Pashto',
            Persian: 'Persan',
            Polish: 'Polonais',
            Portuguese: 'Portugais',
            Punjabi: 'Pendjabi',
            Romanes: 'Romanes',
            Romani: 'Romani',
            Romanian: 'Roumain',
            Russian: 'Russe',
            Sami: 'Sami',
            Serbian: 'Serbe',
            Sign_language: 'Langue des Signes',
            Slovak: 'Slovaque',
            Slovene: 'Slovène',
            Somali: 'Somali',
            Sorani: 'Sorani',
            Spanish: 'Espagnol',
            Swahili: 'Swahili',
            Swedish: 'Suédois',
            Tagalog: 'Tagalog',
            Tamil: 'Tamil',
            Thai: 'Thaïlandais',
            Tigrinya: 'Tigrinya',
            Turkish: 'Turc',
            Ukrainian: 'Ukrainien',
            Urdu: 'Urdu',
            Uyghur: 'Ouïghour',
            Vietnamese: 'Vietnamien',
            Wolof: 'Wolof',
        },
    },
    emailverification: {
        headerLabel: 'Vérification email',
        verifyingEmail: "Vérification de l'email",
        emailVerifySuccess: 'Votre email a été vérifié !',
        emailVerifyFailure:
            "Une erreur s'est produite... réessayez plus tard ou contactez le support.",
        gotoMyPage: 'Revenir à Ma page',
    },
    errors: {
        defaultErrorMessage: "Une erreur s'est produite !",
        logInErrorText: {
            invalidCredentials: "Nom d'utilisateur ou mot de passe incorrect.",
            inactiveUser:
                "L'utilisateur correspondant à cette adresse email est inactif. Vérifiez votre email pour l'activation de votre compte ou essayez de réinitialiser votre mot de passe.",
            default: 'Authentification impossible.',
        },
        registerErrorText: {
            passwordTooShort: "Le mot de passe doit être composé d'au moins 8 chiffres.",
            emailAlreadyInUse: 'Cette adresse email est déjà utilisée.',
            emailTaken:
                "Cette adresse email est déjà utilisée. Si vous avez utilisé l'email de votre école, cela peut arriver parce que vous aviez un utilisateur avant la mise à jour de la plateforme (à higheredtalent.org).",
            default: 'Impossible de créer un utilisateur.',
        },
        invalidTokenText: {
            default: "Le lien d'activation n'est pas valide ou a expiré.",
        },
        passwordErrorText: {
            passwordTooShort: "Le mot de passe doit être composé d'au moins 8 chiffres.",
            requireNonAlphanumeric: 'Le mot de passe doit contenir au moins un caractère spécial.',
            requireLowerCase: 'Le mot de passe doit contenir au moins une lettre minuscule.',
            requireUpperCase: 'Le mot de passe doit contenir au moins une lettre majuscule.',
            requireUniqueChars: 'Le mot de passe doit contenir au moins 6 caractères différents',
            default: 'Impossible de changer le mot de passe',
        },
        recoverErrorText: {
            userNotFound: "L'utilisateur n'existe pas ! Veuillez contacter le support.",
            userAlreadyActive:
                "L'utilisateur est déjà actif! \n Veuillez essayer de vous connecter.",
            emailAlreadyInUse:
                "L'email fourni est déjà utilisé.\nSi vous souhaitez procéder à l'activation du compte, essayez une autre adresse email ou un autre identifiant. Sinon, retournez à la page d'accueil et connectez-vous à votre compte.",
            default: "Impossible d'activer le compte.\nVeuillez réessayer plus tard.",
        },
        socialAuthErrorText: {
            errorTitle: 'Impossible de se connecter avec {provider}',
            invalidProviderGoogle:
                "L'utilisateur avec l'email fourni n'est pas connecté à Google. Veuillez essayer par exemple de vous connecter avec LinkedIn, Facebook, ou avec une adresse email.",
            invalidProviderFacebook:
                "L'utilisateur avec l'email fourni n'est pas connecté à Facebook. Veuillez essayer par exemple de vous connecter avec Google, LinkedIn, ou avec une adresse email.",
            invalidProviderLinkedIn:
                "L'utilisateur avec l'email fourni n'est pas connecté à LinkedIn. Veuillez essayer par exemple de vous connecter avec Google, Facebook ou avec une adresse email.",
            invalidProviderWeChat:
                "L'utilisateur avec l'email fourni n'est pas connecté à WeChat. Veuillez essayer par exemple de vous connecter avec Google, Facebook ou avec une adresse email.",
        },
        uniConnErrorText: {
            emailNotAvailable:
                "L'email que vous avez fourni est déjà utilisé. Cela peut être dû au fait que vous aviez un utilisateur avant la mise à niveau de la plateforme (à higheredtalent.org). Veuillez contacter le support.",
            invalidEmailDomain:
                "L'email fourni ne correspond pas à l'adresse email de l'école. Veuillez choisir l'école correspondante.",
            existingConnection: "L'utilisateur est déjà connecté à l'école.",
            default: 'Impossible de lancer la vérification.',
        },
        spotlightErrors: {
            userUpdate: {
                emailAlreadyInUse: "L'adresse email est déjà utilisée.",
                default: 'Impossible de mettre à jour',
            },
        },
    },
    favorites: {
        header: 'Mes favoris',
        active: 'Actif',
        expired: 'Expiré',
        expiresThisMonth: 'Date limite de candidature ce mois-ci',
        expiresThisWeek: 'Date limite de candidature cette semaine',
        expiresLater: 'Date limite de candidature plus tardive',
        noActiveFavorites: "Vous n'avez aucune offre favorite.",
        noExpired: "Vous n'avez pas d'offre favorite expirée.",
    },
    findcompanies: {
        headerLabel: 'Rechercher des entreprises',
        companyListLabel: 'Entreprises',
    },
    findjobs: {
        header: 'Rechercher des offres',
        changeFilters: 'Changer les filtres',
        recruitmentModule: {
            body: "Êtes-vous un responsable du recrutement, un représentant services carrières ou simplement\n         intéressé par l'embauche d'étudiants talentueux ?",
            createJob: "Cliquez ici pour créer une offre d'emploi",
        },
    },
    general: {
        documentTitle: "Plateforme d'Offres d'Emploi Globales",
        email: 'Email',
        password: 'Mot de passe',
        confirmPassword: 'Confirmer le mot de passe',
        loading: 'Chargement',
        ok: 'OK',
        save: 'Sauvegarder',
        add: 'Ajouter',
        close: 'Fermer',
        delete: 'Supprimer',
        cancel: 'Annuler',
        done: 'Terminé',
        continue: 'Continuer',
        back: 'Revenir',
        next: 'Suivant',
        finish: 'Terminer',
        success: 'Succès',
        error: 'Erreur',
        description: 'Description',
        months: {
            0: 'Jan',
            1: 'Fev',
            2: 'Mar',
            3: 'Avr',
            4: 'Mai',
            5: 'Juin',
            6: 'Jul',
            7: 'Août',
            8: 'Sep',
            9: 'Oct.',
            10: 'Nov',
            11: 'Déc.',
        },
        days: {
            0: 'Dim',
            1: 'Lun',
            2: 'Mar',
            3: 'Mer',
            4: 'Jeu',
            5: 'Ven',
            6: 'Sam',
        },
        dialogs: {
            helperTexts: {
                checkHasPendingAction: 'Vérification en cours.',
                verifySchoolConnection:
                    'Vérifiez que vous êtes connecté à votre école pour accéder à ces ressources.',
                logInToAccessMoreFeatures:
                    "Des milliers d'Opportunités de Carrières Internationales",
            },
        },
        minutesShort: 'min',
        poweredBy: 'Exécuté Par',
    },
    gptw: {
        company: {
            alt: 'GPTW',
            tooltip: 'Cette entreprise est certifiée "Great Place To Work".',
        },
        posting: {
            label: {
                alt: 'GPTW',
                tooltip: 'Cette offre appartient à une entreprise certifiée "Great Place To Work".',
            },
            detail: {
                alt: 'GPTW',
                tooltip: {
                    isCertified: '{companyName} est un certifié "Great Place To Work".',
                    description:
                        'Lorem ipsum dolor sit amet, conextetur adipiscing elit. Sed fingilla pretium nunv, non vestibulum tellus imperdiet sed.',
                    readMore: 'Cliquez pour en savoir plus',
                },
            },
        },
    },
    jobdetail: {
        detailModule: {
            deadline: 'Date limite de dépôt des candidatures',
            location: 'Lieu',
            employmentType: "Type d'emploi",
            languageRequirements: 'Langues requises.',
            workPermitRequirements: 'Permis de travail requis.',
            preferredEducationField: "Domaines d'études souhaités",
            preferredEducationLevel: "Niveaux d'études souhaités",
            jobTags: 'Tags',
            apply: 'Postuler maintenant',
            verificationRequired: "Vous devez vérifier l'email de votre école pour postuler.",
            verificationRequiredHint: "Vous devez vérifier l'email de votre école pour postuler",
            verificationPending: 'Vous êtes en attente de vérification pour cette école.',
            verificationPendingHint: 'Vous êtes en attente de vérification pour cette école.',
            startDate: 'Début',
        },
        invalidJobAd: {
            caption:
                "Désolé, mais nous n'avons pas pu trouver cette offre. Si vous pensez qu'il s'agit d'une erreur, veuillez contacter le support en utilisant le chatbox ci-dessous.",
            btn: "Rechercher d'autres offres",
        },
    },
    mypage: {
        header: 'Ma page',
        suggestedPositions: 'Offres suggérées',
        favoriteModule: {
            header: 'Mes offres favorites',
            seeAll: 'Voir tous',
            noFavorites: "Vous n'avez pas d'offres favorites actives",
        },
    },
    recoverpassword: {
        createPassword: 'Créer un nouveau mot de passe',
        newPasswordLabel: 'Nouveau mot de passe',
        newPasswordPlaceholder: 'Mot de passe',
        confirmPasswordLabel: 'Confirmer le mot de passe',
        confirmPasswordPlaceholder: 'Confirmer le mot de passe',
        resetPasswordButton: 'Réinitialiser le mot de passe',
        resettingPassword: 'Réinitialisation du mot de passe',
        passwordsNotMatching: 'Les mots de passe ne correspondent pas.',
    },
    recoveruser: {
        headerLabel: "Récupérer l'utilisateur Highered",
        accountActivation: 'Activation du compte',
        step1: {
            header: 'Bienvenue sur notre nouvelle plateforme !',
            subHeader: 'Choisissez comment vous voulez vous connecter à votre compte',
            description:
                'Pour une procédure de connexion plus simple, nous vous recommandons de connecter votre compte à au moins un des services suivants.',
            OR: 'ou',
            emailAndPassword: 'Utilisez votre propre adresse email.',
        },
        step2: {
            header: "Utiliser l'email et le mot de passe",
            description:
                "C'est l'adresse email principale qui sera associée à votre compte. Nous vous recommandons d'utiliser une adresse email différente de votre adresse email école afin de conserver l'accès à vos données après votre diplôme. Vous pouvez facilement contrôler les emails que vous recevez de notre part dans les paramètres de votre compte.",
            invalidEmail: "L'email fourni n'est pas une adresse email valide.",
            passwordsNotMatch: 'Les mots de passe doivent correspondre',
            passwordDescription01:
                'Pour assurer la sécurité de votre compte, vous devez définir un nouveau mot de passe. Veuillez créer un mot de passe avec les éléments suivants :',
            passwordDescription02: 'Minimum 8 caractères',
            passwordDescription03: 'Au moins un caractère en minuscule (a-z)',
            passwordDescription04: 'Au moins un caractère en majuscule (A-Z)',
            passwordDescription05: 'Au moins un chiffre ou un symbole spécial (0-9, !#$ etc)',
            passwordDescription06: 'Au moins 6 caractères uniques',
            repeatPassword: 'Répéter le mot de passe',
        },
        step3: {
            header: "Activation de l'utilisateur",
            loadingHints: {
                0: 'Chargement des données utilisateur',
                1: 'Se préparer',
                2: 'De nouvelles possibilités sont disponibles',
                3: 'Presque fini !',
            },
            successHeader: 'Votre compte est maintenant prêt !',
            successSubheader:
                'Vous pouvez désormais accéder à de nouvelles fonctionnalités exclusives !',
            errorHeader: "Impossible d'activer le compte",
            ifWrongContact: "Si vous pensez que c'est une erreur, veuillez contacter le support.",
            contactForHelp: 'Contacter le support.',
            goBack: 'Retour',
        },
    },
    resourcesInternal: {
        header: 'Ressources',
        resourceTypeHeader: 'Type',
        resourceNoContent: "Votre école n'a pas encore activé la fonction de ressource.",
        resourceFolderNoContent: "Il n'y a pas de ressources disponibles dans ce dossier",
        resourceTitleHeader: 'Titre',
        resourcePublishDateHeader: 'Publié',
        searchPlaceholder: 'Recherche par nom ou mot-clé ...',
        cvTemplateHeader: 'MODÈLE DE CV HIGHERED (ATS-FRIENDLY)',
        cvTemplateSubtitle: 'Téléchargez ici !',
    },
    shared: {
        userNavSection: {
            myPage: 'Ma page',
            myProfile: 'Mon profil',
            myTests: 'Assessments',
            myApplications: 'Candidatures',
            myFavorites: 'Favoris',
            resources: 'Ressources',
            calendar: 'Calendrier',
            documents: 'Importer mon CV',
        },
        searchModule: {
            searchBar: { label: 'Recherche par titre ou mots-clés' },
            filters: { clearFilters: 'Effacer les filtres' },
            filterLimit: {
                title: 'Limite de filtre atteinte',
                message: 'Aucun autre filtre de ce type ne peut être sélectionné',
            },
        },
        postingModule: {
            postingModule: {
                positions: 'Offres',
                estimatedCount: 'de {count} à {totalCount}',
                knownCount: '{count} à {totalCount}',
                noMatchFound: 'Aucune offre ne correspond à vos critères.',
            },
            postItem: { applyBefore: 'Date limite de candidature' },
            postCard: { deadline: 'Date limite' },
        },
        loginModule: {
            emailVerificationTip:
                "Il se peut qu'il faille quelques minutes pour le réceptionner dans votre boîte de réception.",
            noEmail: "Vous n'avez pas reçu l'email ? Veuillez vérifier vos spams ou :",
            logIn: 'Se connecter',
            socialAuthBtns: {
                continueWithFacebook: 'Continuer avec Facebook',
                continueWithGoogle: 'Continuer avec Google',
                continueWithLinkedIn: 'Continuer avec LinkedIn',
                continueWithWeChat: 'Continuer avec WeChat',
            },
            verifyEmail: {
                verifyYourEmail: 'Veuillez vérifier votre email',
                weSentAnEmailTo: 'Nous avons envoyé une vérification à',
                continueToSignIn: 'Continuer pour vous connecter',
                resendEmail: 'Renvoyer le lien de vérification',
                newEmailSent: 'Nouvel email envoyé',
            },
            registerForm: {
                recommendation:
                    "Nous vous recommandons d'utiliser votre adresse email personnelle et non celle de votre\n         école afin de vous assurer que vous aurez accès à vos données après votre \n         diplôme.",
                register: 'Enregistrer',
                passwordsNotMatch: 'Les mots de passe ne correspondent pas',
            },
            logInPaper: {
                useEmail: 'ou utiliser votre email.',
                noAccount: "Vous n'avez pas de compte ?",
                signUp: "S'inscrire",
                logInToAccess: 'Connectez-vous pour accéder à cette fonctionnalité',
                showAllOptions: 'Afficher toutes les options de connexion',
                hideAllOptions: 'Afficher moins',
            },
            logInForm: {
                logIn: 'Se connecter',
                forgotPassword: 'Vous avez oublié votre mot de passe ?',
            },
            forgotPassword: {
                title: 'Demander la réinitialisation du mot de passe',
                description:
                    "Pas d'inquiétude - tout le monde oublie son mot de passe de temps en temps.\n                Saisissez votre email ci-dessous pour réinitialiser votre mot de passe",
                resetPassword: 'Réinitialiser le mot de passe',
                emailSentTitle: "Le lien d'activation est en route !",
                emailHasBeenSent:
                    'Un email a été envoyé à \n                            <br>\n                            <strong>{email}</strong>\n                            <br>\n                            avec les instructions pour réinitialiser votre mot de passe.Veuillez vérifier votre\n                            boîte de réception.',
                noEmail: 'Aucun email reçu ?',
                sendEmailOneMoreTime: "Envoyez l'email encore une fois",
                resendErrorTitle: 'Erreur survenue lors de la récupération du mot de passe',
                resendErrorMessage:
                    "Impossible d'envoyer l'email de récupération du mot de passe. L'adresse email était-elle correcte?",
            },
        },
        termsAndConds: {
            termsAndConditions: 'Termes et conditions',
            privacyPolicy: 'Politique de confidentialité',
            talentPanel: 'École/Employeur ?',
        },
        favoriteModule: {
            favoriteCard: {
                deleted: 'Effacé',
                deletedTitle: "Cette offre n'est plus disponible",
            },
        },
        pageNotFound: {
            header: '404',
            description: "Il semble que la page que vous recherchiez n'existe plus.",
            goToHome: "Aller à la page d'accueil",
            contactus: 'Nous contacter',
        },
        chat: {
            liveNow: 'En direct sur le chat maintenant !',
            seeAll: 'Tout',
            schoolSpecificChats: 'Accès rapide',
            help: "Besoin d'aide ?",
            chatExistsLabel: 'Chat existe',
        },
        countdown: {
            day: 'jour',
            days: 'jours',
            hour: 'heure',
            hours: 'heures',
            minute: 'minute',
            minutes: 'minutes',
            second: 'seconde',
            seconds: 'secondes',
        },
    },
    spotlight: {
        header: 'Mon profil',
        saveChangesToSubmit: "Sauvegardez votre profil pour que les changements s'appliquent.",
        saveChanges: 'Enregistrer les modifications',
        saveSuccessful: 'Vos modifications ont été enregistrées avec succès',
        personalDetails: {
            header: 'Données personnelles',
            firstName: 'Prénom',
            lastName: 'Nom',
            nationality: 'Nationalité',
            gender: 'Genre',
            uploadProfileImage: 'Ajouter une photo',
            genderOptions: {
                male: 'Homme',
                female: 'Femme',
                other: 'Autre',
                none: 'Je préfère ne pas renseigner',
                unknown: 'Inconnu',
            },
            wrongFileTypeErrorHeader: 'Type de fichier non valide',
            wrongFileTypeErrorDescription: 'Vous ne pouvez importer que des images',
        },
        summary: { header: 'Sommaire' },
        contactDetails: {
            header: 'Coordonnées du contact',
            contactEmail: 'Email du contact',
            phoneNumberHeader: 'Numéro de téléphone portable',
            countryCode: 'Code postal',
            phoneNumber: 'Numéro de téléphone',
            invalidEmail: "L'email renseigné n'est pas une adresse email valide.",
            permanentEmail:
                "NOTE : Ce changement est permanent. Vous ne pouvez définir votre adresse email qu'une seule fois.",
        },
        languages: {
            header: 'Langues',
            languageLabel: 'Langue',
            levelLabel: 'Niveau',
            addLanguage: 'Ajouter une nouvelle langue',
            proficiencies: {
                '22f882cc-3cb0-4cfd-a590-ef010f4d798b': 'Niveau débutant',
                '82edcac6-693b-42ea-bf24-0a52774f395c': 'Niveau professionnel intermédiaire',
                'a97f6798-7280-4ce7-8896-6d4a8fb58c63': 'Niveau professionnel avancé',
                '93b37709-3f2d-4853-ac77-b8c0dd07243e': 'Niveau professionnel expérimenté',
                '250d296e-d6db-46fb-8c44-07950db80ec4': 'Niveau natif ou bilingue',
            },
        },
        education: {
            header: 'Parcours scolaire',
            addEducation: 'Ajouter un parcours scolaire',
            notGraduated: 'Pas encore diplômé',
            graduatedIn: 'Diplômé en {date}',
            dialog: {
                addNewEducation: 'Ajouter un nouveau parcours scolaire',
                degreeTitle: 'Programme',
                institution: 'Ecole',
                degreeType: 'Diplôme',
                fieldOfStudy: "Champ d'études",
                cannotFindField: "Je ne trouve pas mon champ d'études",
                studyStart: 'Mois de début',
                studyEnd: 'Mois de remise des diplômes',
                invalidDegreeTitle: 'Vous devez indiquer le titre de votre programme.',
                invalidSchool: 'Vous devez sélectionner une école.',
                invalidStartDate: 'Veuillez sélectionner une date de début.',
                invalidEndDate: 'Veuillez sélectionner une date de remise des diplômes.',
                invalidStudyPeriod:
                    'Vous ne pouvez pas obtenir votre diplôme avant la date de début.',
                invalidDegreeField: "Veuillez saisir un champ d'études valide.",
                invalidDegreeLevel: 'Veuillez sélectionner un niveau de diplôme valide.',
                selectStartDate: 'Date de début',
                selectEndDate: 'Date de remise des diplômes',
                degrees: {
                    '5b468395-7bf7-4f14-88d9-32096884d4ef': 'Bachelor',
                    '09f419fa-1517-41ce-970c-df0d073fc440': 'Master',
                    '2c917ed6-5bb7-4e23-95ab-60c55d8df135': 'MBA',
                    '1fff1451-f07c-415c-954a-63b1e5f44fc8': 'DBA',
                    '2fbd6155-d939-40cc-970d-283be0aef433': 'PHD',
                },
                diciplins: {
                    '383c2086-24da-4fe2-977b-7e3d4da85f8e': 'Agriculture',
                    'c8fb1348-bdac-4ed3-af7a-a831376d04b7': 'Sciences Appliquées',
                    '5c665d94-5124-4226-a4f6-da8cca47e3f6': 'Arts, Design et Architecture',
                    '06b028e2-d7ed-4281-8668-1009d6da1c35': 'Commerce et Gestion',
                    '747624bb-0174-4961-a3c0-dbe4f1cb750d': 'Sciences Informatiques et IT',
                    'ede2bbdb-7a1d-466c-99e5-bcab52e07d69': 'Économie',
                    '5c0432d4-9297-429a-85c4-3305d207764e': 'Éducation et Formation',
                    '8198b6ea-5b28-4be2-afbc-45df759c65cb': 'Ingénierie et Technologie',
                    '7e5c0527-d1ec-4125-945e-138ec473e8dd':
                        'Études Environnementales et Sciences de la Terre',
                    '3babe28b-6285-4a03-b0b8-43f55be393cd': 'Hôtellerie, Loisirs et Sports',
                    '9eebcc51-385e-4122-88a1-6dd3efbaf896': 'Humanitaire',
                    '390cf111-b55a-4bb7-a6b6-1cc2b21a248f': 'Journalisme et Médias',
                    'a2744908-9521-4330-a07d-3680b058d0a6': 'Loi',
                    '947993e1-b723-4d85-8cd9-a4ae46cd623e': 'Marketing',
                    'c98802c8-74a5-4a98-99ba-84eb76fd1a60':
                        'Master de Science en Innovation et Affaires',
                    'bca263cc-3d17-4ad8-b70e-e2bfe04421fa': 'Master en Management & Développement',
                    'a37667e2-5713-4157-82e9-78c10760d2de': 'Master Spécialisé Data Science',
                    '72277bb7-9d5e-422a-a2b4-8a8fb8be7143': 'Médecine et Santé',
                    'bd84a8cd-ce66-4c61-86a8-7fcb6644cc5d': 'Master Spécialisé Finance',
                    '9e665ac9-9611-4508-af4b-22e91f167ea4':
                        'Master Spécialisé Commerce International',
                    'baf5bb0a-d0ab-4c13-aacc-c6a8a90e2fcf': 'Master Spécialisé Business Analytics',
                    '7d832109-642a-4730-aada-26927eb683ee': 'Master Spécialisé Management',
                    'baf05a5a-faba-4f30-9254-9cd73bb63bbf': 'Sciences Naturelles et Mathématiques',
                    '828cc4ac-1f2b-4133-8e29-ba1347585ae6': 'Sciences Sociales',
                    '44c1f8cf-8696-4638-bc03-9763c2de32af': 'Autres',
                },
            },
        },
        workAuthorization: {
            header: 'Autorisation de Travail',
            addWorkAuthorization: 'Ajouter une autorisation de travail',
            implicitValue: 'Basé sur votre nationalité',
            dialog: {
                selectCountry: 'Sélectionner un pays',
                addEuWorkAuthorization: "Ajouter une autorisation de travail de l'UE",
            },
        },
        communication: {
            header: 'Communication',
            sendMeUpdatesDescription:
                "Je souhaite recevoir les nouveautés sur les carrières, les offres et sur l'entreprise par courriel.",
        },
        errors: {
            imageUpload: {
                title: "Impossible d'importer l'image.",
                message: "L'image est trop grande !",
            },
        },
        exitDialog: {
            title: 'Les modifications non sauvegardées seront perdues',
            message:
                'Vous essayez de quitter la page sans enregistrer vos modifications. Voulez-vous enregistrer votre profil avant de passer à autre chose ?',
            stayAction: 'Restez sur cette page',
            saveAction: 'Sauvegarder le profil',
            continueAction: 'Continuer sans sauvegarder',
        },
    },
    tests: {
        header: 'Tests',
        unauthorized:
            "Les tests sont actuellement fermés. Vous n'avez pas encore accès à ces fonctionnalités. Elles seront bientôt disponibles !",
        error: 'Une erreur est survenue lors du chargement des tests. Veuillez réessayer plus tard.',
        assessmentModule: { header: 'Votre assessment' },
        completedYourProfile:
            'Vous devez compléter votre profil pour avoir accès à cet assessement.',
        toMyProfile: 'Modifier mon profil',
    },
    vfair: {
        header: 'Événements virtuels EFMD',
        activeNow: 'En cours',
        visibilityPrivate: 'Privé',
        visibilityNetwork: 'Réseau',
        visibilityOpen: 'Ouvert',
        interested: "S'enregistrer",
        attend: "Participer à l'événement",
        enterEvent: "Accéder à l'événement virtuel",
        notinterested: 'Je ne suis plus intéressé(e)',
        shownInterest: 'Enregistré',
        signUpToday: "Inscrivez-vous aujourd'hui !",
        vfairsInfo:
            'Entrez en contact avec des entreprises et des organisations du monde entier, dans un espace moderne qui permet une interaction en temps réel entre recruteurs et candidats. Cliquez sur le forum qui vous intéresse et inscrivez-vous pour recevoir des notifications.',
        recruitingOrgs: 'Entreprises et Organisations qui recrutent',
        preRegistered: 'Pré-enregistré',
        prepareForTheFair: 'Préparez-vous pour le forum',
        privateVFairHeader: 'Événement virtuel école',
        privateVFairMessage:
            "Cet événement virtuel est hébergé sur une plateforme de l'école EFMD et ne peut donc pas être accessible d'ici.",
        schoolNotJoinedNetworkEventMessage:
            "Votre école ne s'est pas encore inscrite à cet événement virtuel, contactez votre directeur de programe ou votre service carrières pour leur demander de participer.",
        companyNotJoinedNetworkEventMessage:
            "Votre organisation n'a pas de Stand Virtuel actif à cet événement. Contactez Highered pour demander la participation de votre organisation.",
        pavilions: 'Pavillons',
        general: 'Général',
        allCompanies: 'Toutes les entreprises',
        lobby: 'Lobby',
        inviteCode: "Code d'invitation",
        eventRequiresInvitation: 'Cet événement nécessite une invitation',
        haveCode: "J'ai un code",
        checkCode: 'Vérifier le code',
        invalidCode: 'Code non valide',
        registeredSuccessfully: 'Enregistré avec succès',
        pavilionTabs: {
            home: 'accueil',
            companies: 'entreprises',
            articles: 'articles',
            jobs: "offres d'emploi",
            events: 'événements',
        },
        events: {
            noEventsAvailable: 'Aucun événement disponible',
            showCompleted: 'Evénements passés',
            hideCompleted: 'Masquer les événements passés',
            liveNow: 'En direct maintenant',
            joinTheEvent: "Rejoindre l'événement",
            addToCalendar: 'Ajouter au calendrier',
        },
        links: {
            masterclasses: {
                header: 'Masterclasses',
                buttonCaption: 'Regardez les masterclasses',
                description:
                    'Découvrez un large éventail de masterclasses de grande qualité, dont " Optimisation du CV pour être embauché ", " Rock Your Linkedin Profile " et " Négociation de Salaire ", parmi beaucoup d\'autres, pour toutes les étapes de votre trajectoire de carrière !',
            },
            detailsmasterclass: { header: 'Assister à la masterclass' },
            cv: {
                header: 'Modèle de CV',
                buttonCaption: 'Télécharger le modèle de CV',
                description:
                    'Accédez au modèle de CV Highered compatible ATS, et faites bonne impression auprès des recruteurs.',
            },
            elevatorPitch: {
                header: 'Challenge Elevator Pitch',
                buttonCaption: 'Envoyez votre pitch.',
                description:
                    'Relevez le défi du "Challenge Pitch Perfect" ! C\'est l\'occasion de présenter votre valeur ajoutée à des centaines de recruteurs des plus grandes entreprises et organisations du monde !',
            },
        },
        footerHeaders: {
            social: 'Suivez-nous pour plus de nouveautés',
            sponsored: 'Sponsorisé par',
            organized: 'Organisé par',
        },
        educationPopup: {
            step00: {
                header: 'Partagez votre parcours scolaire',
                subtitle: 'Pour continuer, dites en plus sur vous aux employeurs.',
                continueLabel: 'Ajouter ma formation',
                leaveLabel: 'Ignorer',
            },
            step01: { header: 'Racontez-nous votre parcours.' },
            step02: { loadingLabel: 'Juste un instant...' },
            step03: {
                header: 'Parcours scolaire complet',
                subtitle:
                    'Vous pouvez désormais partager votre profil et être plus intéressant auprès des employeurs.',
                continueLabel: 'Continuez à explorer les événements virtuels',
            },
            error: {
                header: "Oups ! Une erreur s'est produite !",
                subtitle:
                    "Nous n'avons pas été en mesure de stocker vos informations scolaires. Veuillez réessayer plus tard.",
            },
        },
    },
};
